document.addEventListener('wishlist-updated', function (event) {
  try {
    if (!event?.detail?.handle) {
      return;
    }

    const handle = event.detail.handle;

    /*
     * Wishlist veilig uitlezen.
     * Het oorspronkelijke wishlist-script heeft localStorage
     * al bijgewerkt voordat wishlist-updated wordt afgevuurd.
     */
    let wishlist = [];

    try {
      const storedWishlist = localStorage.getItem('wishlist');

      if (storedWishlist) {
        const parsedWishlist = JSON.parse(storedWishlist);

        if (Array.isArray(parsedWishlist)) {
          wishlist = parsedWishlist;
        }
      }
    } catch (error) {
      console.warn('Wishlist kon niet gelezen worden.', error);
    }

    const added = wishlist.some(function (item) {
      return item && item.handle === handle;
    });

    /*
     * Productinformatie ophalen
     */
    const wishlistToggle = event.target;

    let productName = handle;
    let productUrl =
      window.location.origin + '/products/' + handle;

    if (
      wishlistToggle &&
      typeof wishlistToggle.closest === 'function'
    ) {
      const productCard =
        wishlistToggle.closest('.product-card');

      if (productCard) {
        const titleElement =
          productCard.querySelector('.productGridItem__title');

        if (titleElement?.textContent?.trim()) {
          productName = titleElement.textContent.trim();
        }

        const href = productCard.getAttribute('href');

        if (href) {
          try {
            productUrl = new URL(
              href,
              window.location.origin
            ).href;
          } catch (error) {
            console.warn(
              'Product URL kon niet opgebouwd worden.',
              error
            );
          }
        }
      }
    }

    /*
     * DataLayer initialiseren
     */
    window.dataLayer = window.dataLayer || [];

    /*
     * Vorige ecommerce-data leegmaken.
     * Dit wordt door Google aanbevolen om oude ecommerce-data
     * niet per ongeluk opnieuw mee te sturen.
     */
    window.dataLayer.push({
      ecommerce: null
    });

    /*
     * GA4 ecommerce event
     */
    window.dataLayer.push({
      event: added
        ? 'add_to_wishlist'
        : 'remove_from_wishlist',

      ecommerce: {
        items: [
          {
            item_id: handle,
            item_name: productName,
            item_url: productUrl
          }
        ]
      }
    });

  } catch (error) {
    /*
     * Tracking mag nooit invloed hebben op de webshop.
     */
    console.warn('Wishlist tracking error:', error);
  }
});